__turbopack_context__.v({
  "Branch": "Position-module-sass-module__G22ksG__Branch",
  "Button": "Position-module-sass-module__G22ksG__Button",
  "Copy": "Position-module-sass-module__G22ksG__Copy",
  "Location": "Position-module-sass-module__G22ksG__Location",
  "Main": "Position-module-sass-module__G22ksG__Main",
  "Position": "Position-module-sass-module__G22ksG__Position",
  "Type": "Position-module-sass-module__G22ksG__Type",
  "benmax-maintenance-services": "Position-module-sass-module__G22ksG__benmax-maintenance-services",
});
